<template>
  <div id="loading-element" v-show="show">
    <div class="center-align">
      <div class="preloader-wrapper big active">
        <div class="spinner-layer spinner-blue">
          <div class="circle-clipper left">
            <div class="circle"></div>
          </div><div class="gap-patch">
            <div class="circle"></div>
          </div><div class="circle-clipper right">
            <div class="circle"></div>
          </div>
        </div>

        <div class="spinner-layer spinner-red">
          <div class="circle-clipper left">
            <div class="circle"></div>
          </div><div class="gap-patch">
            <div class="circle"></div>
          </div><div class="circle-clipper right">
            <div class="circle"></div>
          </div>
        </div>

        <div class="spinner-layer spinner-yellow">
          <div class="circle-clipper left">
            <div class="circle"></div>
          </div><div class="gap-patch">
            <div class="circle"></div>
          </div><div class="circle-clipper right">
            <div class="circle"></div>
          </div>
        </div>

        <div class="spinner-layer spinner-green">
          <div class="circle-clipper left">
            <div class="circle"></div>
          </div><div class="gap-patch">
            <div class="circle"></div>
          </div><div class="circle-clipper right">
            <div class="circle"></div>
          </div>
        </div>
      </div>
      <p class="blinking center-align">Cargando</p>
      <p class="center-align">Por favor Espere</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ['show'],
  watch: {
    show (val) {
      if (val) {
        document.documentElement.style.overflow = 'hidden' // firefox, chrome
        document.body.scroll = 'no' // ie only
      } else {
        document.documentElement.style.overflow = '' // firefox, chrome
        document.body.scroll = 'yes' // ie only
      }
    }
  },
  destroyed () {
    document.documentElement.style.overflow = '' // firefox, chrome
    document.body.scroll = 'yes' // ie only
  }
}
</script>

<style lang="scss" scoped>
  .blinking {
    animation: blinker 0.5s linear infinite;
  }
  @keyframes blinker {
    50% { opacity: 0; }
  }
  #loading-element {
    position: fixed;
    background-color: #ffffff;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue